export default function Toast({ toast }) {
  if (!toast) return null;
  const colors = { ok: 'var(--ok)', error: 'var(--danger)', info: 'var(--accent)' };
  return (
    <div style={{
      // 400, а не 300: у оверлея модалки тоже 300, но он уходит в портал
      // document.body и оказывается в DOM позже — при равном z-index тост
      // оказывался под ним и ошибка была не видна вообще.
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', zIndex: 400,
      display: 'flex', alignItems: 'center', gap: 12, padding: '14px 22px',
      background: 'var(--surface-3)', border: `1px solid ${colors[toast.type] || 'var(--line)'}`,
      borderRadius: 'var(--r-md)', boxShadow: 'var(--shadow-pop)', animation: 'popIn .3s var(--ease-spring) both',
      maxWidth: '92vw',
    }}>
      <span style={{
        width: 8, height: 8, borderRadius: '50%',
        background: colors[toast.type] || 'var(--accent)',
        boxShadow: `0 0 10px ${colors[toast.type] || 'var(--accent)'}`,
      }} />
      <span style={{ fontSize: 14, color: 'var(--fg)' }}>{toast.msg}</span>
    </div>
  );
}
// deploy